/**
 * 隐患实时报警看板 — POST /api/produce/kanban/safety-hazard-alarm-board
 */
import request from '@/router/axios'

const API = '/api/produce/kanban/safety-hazard-alarm-board'

function unwrap(res) {
  const body = res && res.data
  if (body && Object.prototype.hasOwnProperty.call(body, 'data')) return body.data
  return body
}

/**
 * @param {object} params rectifyStatus, acceptanceResult, problemTypeKeyword, deptKeyword, onlyOverdue, startTime, endTime, limit
 * @returns {Promise<{ list: array }>}
 */
export function fetchSafetyHazardAlarmBoard(params = {}) {
  return request({
    url: API,
    method: 'post',
    data: params
  }).then(unwrap)
}
